// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"34d2d009fa9b7a32fe47","655":"99e136a526eb66839f35"}[chunkId] + ".js";
};